import React, { useState } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
// import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import ToolkitProvider from "react-bootstrap-table2-toolkit";

import ModalViewAssoc from "../AdminDashboard/modalViewAssoc";
import dashboardService from "../../services/dashboard.service";

// const { SearchBar } = Search;
import {
  // Row,
  // Col,
  Form,
  Button,
  FormControl,
  Container,
} from "react-bootstrap";

// Import Service
import FarmermasterService from "../../services/farmermaster.service";
// import authService from "../../services/auth.service";

//Import Modal
// import Modalapprove from "./Modalapprove";

// import moment from "moment/min/moment-with-locales";
import moment from "moment";
import "moment/locale/th";
moment.locale("th");

//Import Loading
import LoadingAlert from "../../components/LoadingAlert";

const SearchMaster = () => {
  const [show_assoc, setShow_assoc] = useState(false);
  const [assocdata, setAssocdata] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [data, setData] = useState([]);
  const [textSearch, setTextSearch] = useState("");
  //   const [farmerselect, farmerSetselect] = useState({});

  //   const user = authService.getCurrentUser();

  const getData = () => {
    setLoading(true);
    FarmermasterService.searchFarmerMaster({ textSearch: textSearch })
      .then((response) => {
        setData(response.data.data);
      })
      .catch((error) => {
        console.error("error fetching data: ", error);
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleSearch = (e) => {
    e.preventDefault();
    getData();
  };
  const handleSearchChange = (e) => {
    setTextSearch(e.target.value);
  };
  const clickViewAssoc = (id) => {
    console.log(id);
    setAssocdata([]);
    setLoading(true);
    dashboardService
      .getAssocByFarmer(id)
      .then((response) => {
        console.log(response.data.data);
        setAssocdata(response.data.data);
      })
      .catch((error) => {
        console.error("error fetching data: ", error);
        // setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
    setShow_assoc(true);
  };

  const actionsViewAssoc = (cell, row) => {
    if (cell !== null) {
      return (
        <div>
          {" "}
          <a onClick={() => clickViewAssoc(row.masteridcard)}>{cell}</a>
        </div>
      );
    } else {
      return "-";
    }
  };
  const columns = [
    {
      text: "masterid",
      dataField: "masterid",
      sort: true,
      // filter: textFilter({ placeholder: "ค้นหา" }),
      hidden: true,
    },
    {
      text: "ชื่อ-สกุล",
      dataField: "mastername",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "15%" };
      },
      style: {
        wordBreak: "break-word",
        textAlign: "left",
      },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },
    {
      text: "เลขประชาชน",
      dataField: "masteridcard",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "12%" };
      },
      style: {
        wordBreak: "break-word",
      },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },
    {
      text: "สถานะ",
      dataField: "status_text",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      style: {
        wordBreak: "break-word",
      },
      // style: {
      //   wordBreak: "break-word",
      // },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },
    {
      text: "ที่อยู่",
      dataField: "address",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "15%" };
      },
      style: {
        // wordBreak: "break-word",
        textAlign: "left",
      },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },
    {
      text: "เลข หน.กลุ่ม",
      dataField: "farmer_card",
      sort: true,
      editable: false,
      filter: textFilter({ placeholder: "ค้นหา" }),
      searchable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "12%" };
      },
      style: {
        wordBreak: "break-word",
      },
    },
    {
      text: "สังกัดสมาคม",
      dataField: "assocsigned",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "8%" };
      },
      style: {
        wordBreak: "break-word",
      },
      // filter: textFilter({ placeholder: "ค้นหา" }),
      formatter: actionsViewAssoc,
    },
    {
      text: "เริ่ม",
      dataField: "start_date",
      sort: true,
      editable: false,
      filter: textFilter({ placeholder: "ค้นหา" }),
      formatter: (cell) => {
        if (cell != "-") {
          return moment(new Date(cell)).add(543, "year").format("ll");
        } else {
          return cell;
        }
      },
      filterValue: (cell) => {
        if (cell != "-") {
          return moment(new Date(cell)).add(543, "year").format("ll");
        } else {
          return cell;
        }
      },
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      style: {
        wordBreak: "break-word",
      },
    },
    {
      text: "สิ้นสุด",
      dataField: "end_date",
      sort: true,
      editable: false,
      filter: textFilter({ placeholder: "ค้นหา" }),
      formatter: (cell) => {
        if (cell != "-") {
          return moment(new Date(cell)).add(543, "year").format("ll");
        } else {
          return cell;
        }
      },
      filterValue: (cell) => {
        if (cell != "-") {
          return moment(new Date(cell)).add(543, "year").format("ll");
        } else {
          return cell;
        }
      },
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      style: {
        wordBreak: "break-word",
      },
    },
  ];

  const pagination = paginationFactory({
    page: 1,
    sizePerPage: 5,
    firstPageText: "|<",
    lastPageText: ">|",
    nextPageText: ">>",
    prePageText: "<<",
    showTotal: true,
    alwaysShowAllBtns: true,
    onPageChange: (page, sizePerPage) => {
      console.log("page", page);
      console.log("sizePage", sizePerPage);
    },
    onSizePerPageChange: (page, sizePerPage) => {
      console.log("page", page);
      console.log("sizePage", sizePerPage);
    },
  });

  if (error) return `Error :${error}`;

  return (
    <Container>
      <ModalViewAssoc
        show={show_assoc}
        data={assocdata}
        setdata={(b) => setAssocdata(b)}
        hidden={(a) => setShow_assoc(a)}
      />
      {loading ? <LoadingAlert /> : ""}
      <Form className="d-flex">
        <FormControl
          size="sm"
          type="search"
          placeholder="ค้นหาด้วย ชื่อ,นามสกุล,บัตรประชาชน,เลขชาวไร่อ้อย"
          className="me-2"
          aria-label="Search"
          onChange={handleSearchChange}
          onKeyPress={(e) => e.keyCode === 13 && handleSearch()}
        />
        <Button
          type="submit"
          variant="info"
          onClick={handleSearch}
          style={{ margin: 0 }}
        >
          ค้นหา
        </Button>
      </Form>
      <ToolkitProvider
        bootstrap4
        keyField="masterid"
        data={data}
        columns={columns}
        search
      >
        {(prop) => (
          <React.Fragment>
            <div>
              <div className="text-left">
                {/* <button
                  className="btn btn-primary"
                  // onClick={handleClickAdd}
                  style={{ padding: ".375rem .75rem", fontSize: "1rem" }}
                >
                  ตรวจสอบ
                </button> */}
                {/* <SearchBar {...prop.searchProps} /> */}
              </div>
            </div>
            <hr />
            <div style={{ width: "auto" }}>
              <BootstrapTable
                // selectRow={{
                //   mode: "checkbox",
                //   headerColumnStyle: {
                //     // textAlign: "center",
                //     width: "5%",
                //   },
                //   selectColumnStyle: {
                //     style: { background: "darkgray" },
                //   },
                // }}
                bootstrap4
                // keyField="masterid"
                columns={columns}
                data={data}
                pagination={pagination}
                //   cellEdit={cellEditFactory({
                //     mode: "click",
                //     blurToSave: true,
                //     afterSaveCell,
                //   })}
                filter={filterFactory()}
                // loading={true}
                {...prop.baseProps}
                // cellEdit={cellEditFactory({
                //   mode: "click",
                //   blurToSave: true,
                //   afterSaveCell: handleChange,
                //   beforeSaveCell: beforeSaveCell,
                // })}
              />
            </div>
          </React.Fragment>
        )}
      </ToolkitProvider>
    </Container>
  );
};

export default SearchMaster;
